module.exports = __webpack_public_path__ + "img/car-15.dcee03bf.jpg";